export const INTERIOR_DOOR_TYPE_IDS = '369'; // API term ID's for interior & interior-wood.
export const EXTERIOR_DOOR_TYPE_IDS = '370'; // API term ID's for exterior & exterior-wood.
